import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from "react-redux";
import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { USER_MESSAGE } from "../../../actions/User";



const mutatePostAddData = async ({ apiData }) => {
    let apiUrl = `${config.ENDPOINTS["datalake"]}/adg/set_metadata`;

    const response = await axios.post(apiUrl, apiData,
        {
            headers: setHeaders()
        });
    if (!response?.data) {
        throw new Error('Network response was not ok');
    }
    return response?.data;
};

const useMutateDGPlateCreate = () => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const mutation = useMutation(mutatePostAddData, {
        mutationKey: 'addDGPlate',
        onSuccess: (apiData) => {
            //const { plate_name, batch_id } = data;
            queryClient.invalidateQueries("autodgplates");
            queryClient.invalidateQueries("QlpFiles");
            dispatch({
                type: USER_MESSAGE,
                msgType: "success",
                text: "DG Plate created successfully",
                key: crypto.randomUUID()
            });
        },
        onError: (error) => {
            queryClient.invalidateQueries("autodgplates");
            queryClient.invalidateQueries("QlpFiles");
            dispatch({
                type: USER_MESSAGE,
                msgType: "error",
                text: `${error?.response?.data?.data?.message}`,
                key: crypto.randomUUID()
            });
        },
    }
    );
    return mutation;
};

export default useMutateDGPlateCreate;